import React from "react";

interface Props {
  /** The raw JSON string held in each Try panel's `responseBody` state. */
  responseBody: string | null;
}

/**
 * Status line under a Try panel's response card. Shows the real status the API
 * returned (403, 429, 500 …) and appends the DPI error code when the endpoint
 * populates one — Get Token and 429 responses do not.
 */
function ResponseStatusFooter({ responseBody }: Props) {
  if (!responseBody) {
    return <p className="text-muted mb-0">No request sent yet.</p>;
  }

  let response: { statusCode?: number; errorCode?: string | null };

  try {
    response = JSON.parse(responseBody);
  } catch {
    return <p className="text-danger mb-0">Response could not be parsed.</p>;
  }

  if (response.statusCode === 200) {
    return <p className="text-primary mb-0">200 - successful</p>;
  }

  return (
    <p className="text-danger mb-0">
      {response.statusCode === 0
        ? "Network error - request did not reach the API"
        : `${response.statusCode} - unsuccessful`}
      {response.errorCode ? ` (${response.errorCode})` : ""}
    </p>
  );
}

export default ResponseStatusFooter;
